import { Field, TextIn, Toggle } from "@/components/forms/Field";
import ImageInput from "@/components/forms/ImageInput";
import { useEffect, useState } from "react";
import api from "@/lib/api";

function RouteSelect({ e, set }) {
  const [sops, setSops] = useState([]);
  useEffect(() => { api.get("/crm/sops").then((r) => setSops(r.data.rows)).catch(() => {}); }, []);
  const route = e.route || (e.outcome === "disqualified" ? "none" : "sop:ad-leads");
  return (
    <Field label="Send lead to" hint="Which SOP the lead enters when it finishes on this ending. DQ: saved in the DQ Leads module, not the pipeline. Use logic rules (e.g. on GMV) to pick the ending.">
      <select className="w-full px-2.5 py-1.5 rounded border text-sm" value={route} onChange={(ev) => set({ route: ev.target.value })} data-testid="ending-route-select">
        {sops.map((s) => <option key={s._id} value={`sop:${s._id}`}>SOP: {s.name}</option>)}
        <option value="dq">DQ Leads module</option><option value="none">No SOP</option>
      </select>
      {route === "dq" && <input className="w-full mt-1.5 px-2.5 py-1.5 rounded border text-sm" placeholder="DQ reason, e.g. GMV below ₹10L" value={e.dq_reason || ""} onChange={(ev) => set({ dq_reason: ev.target.value })} data-testid="ending-dq-reason" />}
    </Field>
  );
}

export default function EndingConfig({ ending: e, onChange, onDelete, canDelete }) {
  const set = (p) => onChange(e.id, p);
  return (
    <div className="space-y-3" data-testid="ending-config">
      <div className="flex items-center text-xs text-neutral-400">Ending screen<span className="ml-auto font-mono text-neutral-600">{e.id}</span></div>
      <Field label="Outcome" hint="Disqualified: lead saved as Disqualified, no Meet booking, no Zapier, no SOP.">
        <div className="flex gap-1">
          {["qualified", "neutral", "disqualified"].map((o) => (
            <button key={o} type="button" onClick={() => set({ outcome: o })} data-testid={`ending-outcome-${o}`}
              className={`px-2.5 py-1 text-xs rounded border capitalize ${e.outcome === o ? "bg-white text-black border-white" : "text-neutral-400"}`}>{o}</button>
          ))}
        </div>
      </Field>
      <RouteSelect e={e} set={set} />
      <Field label="Title" hint="Use {{question_id}} to recall an answer, e.g. {{q_name}}. Booked meeting: {{meeting_datetime}}, {{meeting_date}}, {{meeting_time}}"><TextIn value={e.title} onChange={(v) => set({ title: v })} testid="ending-title" /></Field>
      <Field label="Body">
        <textarea className="w-full px-2.5 py-1.5 rounded border text-sm" rows={4} value={e.body || ""} onChange={(ev) => set({ body: ev.target.value })} data-testid="ending-body" />
      </Field>
      <Field label="Image (optional)"><ImageInput value={e.image_url} onChange={(v) => set({ image_url: v })} testid="ending-image" /></Field>
      <div className="grid grid-cols-2 gap-2">
        <Field label="Transition">
          <select className="w-full px-2.5 py-1.5 rounded border text-sm" value={e.transition || "fade"} onChange={(ev) => set({ transition: ev.target.value })} data-testid="ending-transition">
            <option value="fade">Fade</option><option value="slide">Slide up</option><option value="zoom">Zoom</option>
          </select>
        </Field>
        <div className="flex items-end pb-2"><Toggle checked={e.show_meet !== false} onChange={(v) => set({ show_meet: v })} label="Show Meet time + link" testid="ending-show-meet" /></div>
      </div>
      <div className="rounded border border-[var(--border)] p-2.5 space-y-2">
        <div className="text-xs text-neutral-400">Buttons (optional)</div>
        <Toggle checked={e.add_to_calendar !== false} onChange={(v) => set({ add_to_calendar: v })} label="“Add to Google Calendar” button (shows when a call was booked)" testid="ending-gcal-toggle" />
        {e.add_to_calendar !== false && <Field label="Calendar button text"><TextIn value={e.calendar_label} onChange={(v) => set({ calendar_label: v })} placeholder="Add to Google Calendar" testid="ending-gcal-label" /></Field>}
        <div className="grid grid-cols-2 gap-2">
          <Field label="Redirect button text"><TextIn value={e.button_label} onChange={(v) => set({ button_label: v })} placeholder="Continue" testid="ending-btn-label" /></Field>
          <Field label="Redirect button URL" hint="Leave empty for no button"><TextIn value={e.button_url} onChange={(v) => set({ button_url: v })} placeholder="https://…" testid="ending-btn-url" /></Field>
        </div>
        {e.button_url && <Toggle checked={!!e.button_new_tab} onChange={(v) => set({ button_new_tab: v })} label="Open in a new tab" testid="ending-btn-newtab" />}
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Field label="Auto-redirect URL"><TextIn value={e.redirect_url} onChange={(v) => set({ redirect_url: v })} testid="ending-redirect" /></Field>
        <Field label="Redirect after (s)"><TextIn type="number" value={e.redirect_delay_s} onChange={(v) => set({ redirect_delay_s: v })} testid="ending-redirect-delay" /></Field>
      </div>
      {canDelete && <button className="btn text-xs hover:text-[var(--breach)]" onClick={() => onDelete(e.id)} data-testid="ending-delete">Delete ending</button>}
    </div>
  );
}
